<template>
  <label class="wrapper-radio mr-20 db relative pl-22 mb-6 hand fs-14 w-fit-content">
    <img :src="resolveImgUrl(url)" v-if="isImg" class="img-text" />
<!--    <span class="black v-sub fs-16 lh-24 fw-500 label-radio" v-if="!isImg">{{ label }}</span>-->
    <input
      class="checkbox absolute hand opacity-0 w-0 h-0 v-sub"
      type="radio"
      :name="name"
      :checked="isChecked"
      :value="value"
      @change="$emit('update:change', $event.target.value)"
    />
    <span class="black v-sub fs-16 lh-24 fw-400 label-radio gray-700-brand" v-if="!isImg">{{ label }}</span>
    <span class="checkmark absolute w-16 h-16 br-p-50 bg-white"></span>
  </label>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    url:{
      type: String,
      default: "",
    },
    isImg:{
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: "",
      // required: true
    },
    name: {
      type: String,
      default: "",
      required: true
    },
    value: {
      type: String,
      default: null
    },
    isChecked: {
      type: Boolean,
      default: false
    }
  },
  setup(){
     const resolveImgUrl = (path) => {
      // let images = require.context('../../../assets/images/general', false, /\.png$|\.svg$/)
      // return images('./' + path)
      return 'https://s3-cdn.designerjourneys.com/static/flags/' + path
    }

    return { resolveImgUrl }
  }
});
</script>

<style lang="scss" scoped>
.opacity-0 {
  opacity: 0;
}

.checkmark {
  top: 3px;
  left: 0;
  border: 1px solid rgba(0, 59, 119, 0.2);
  box-shadow: 0px 1px 1px rgba(0, 59, 119, 0.05);
}

.wrapper-radio {
  input:checked ~ {
    .checkmark {
      background-color: #fff;
      // border: 1px solid #a4cbfa;
      border: 1px solid brandColor(brand,800);
      &:after {
        content: "";
        position: absolute;
        display: none;
      }
    }
    .label-radio {
      color: brandColor(gray,950);
      font-family: $font-family-proximanova-medium;
      font-weight: 500;
    }
  }
  .img-text{
    //width: 56px;
    height: 15px;
    vertical-align: -webkit-baseline-middle;
  }
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.wrapper-radio input:checked ~ .checkmark:after {
  display: block;
}

.wrapper-radio .checkmark:after {
  top: 2px;
  left: 2px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  // background: #a4cbfa;
  background-color: brandColor(brand,800);
}

@include phone{
  .wrapper-radio{
    width: fit-content;
    &:last-child{
      margin-bottom: 0;
    }
  }
}
</style>
